export default {
  methods: {
    goBack(base = '/') {
      if (window.history.length === 2) { // This is the first page user loaded so return to main menu
        this.$router.push({ name: base });
      } else {
        this.$router.back();
      }
    },
  },
};
